/**
 * @description 买赠活动（promotionType=3）购物车/订单行分组键
 */

/**
 * @param {Record<string, unknown>} row
 * @returns {string|number|null|undefined}
 */
function rowPromotionId(row) {
  if (row == null || typeof row !== 'object') return null
  const v = row.promotionId ?? row.promotion_id
  if (v === undefined || v === null || v === '') return null
  return v
}

/**
 * @description 买赠活动分组键：同一 `promotionId`（活动 id）归为一组展示
 * @param {Record<string, unknown>} row
 * @returns {string|null}
 */
export function giveawayActivityGroupKeyFromRow(row) {
  if (Number(row?.promotionType ?? row?.promotion_type) !== 3) return null
  const pid = rowPromotionId(row)
  if (pid == null || pid === '') return null
  return `3:${String(pid)}`
}

/**
 * @description 两行是否属于同一买赠活动实例
 * @param {Record<string, unknown>} a
 * @param {Record<string, unknown>} b
 * @returns {boolean}
 */
export function isSameGiveawayActivityGroup(a, b) {
  const ka = giveawayActivityGroupKeyFromRow(a)
  const kb = giveawayActivityGroupKeyFromRow(b)
  if (ka == null || kb == null) return false
  return ka === kb
}

/**
 * @description 买赠「活动 + 主商品」分组键：同活动下同一 prodId 多规格合并展示、赠品挂在最后一行规格下
 * @param {Record<string, unknown>} row
 * @returns {string|null}
 */
export function giveawayProductGroupKeyFromRow(row) {
  if (Number(row?.promotionType ?? row?.promotion_type) !== 3) return null
  const actKey = giveawayActivityGroupKeyFromRow(row)
  if (!actKey) return null
  const pv = row.productVO && typeof row.productVO === 'object' ? row.productVO : {}
  const prodId = row.prodId ?? row.productId ?? pv.prodId
  if (prodId == null || prodId === '') return null
  return `${actKey}:${String(prodId)}`
}

/**
 * @description 两行是否属于同一买赠活动下的同一主商品（多规格合并）
 * @param {Record<string, unknown>} a
 * @param {Record<string, unknown>} b
 * @returns {boolean}
 */
export function isSameGiveawayProductGroup(a, b) {
  const ka = giveawayProductGroupKeyFromRow(a)
  const kb = giveawayProductGroupKeyFromRow(b)
  if (ka == null || kb == null) return false
  return ka === kb
}
